export default __webpack_public_path__ + "static/media/netbit2.2b88bce6.png";